import { LOAD_CONFIG_DATA_MODEL_SUCCESS } from '../../../actions/app/index.tsx';
import { SET_CUSTOM_FILTERS } from '../../../actions/custom-filters/index.tsx';
import type { Action } from '../../../actions/index.tsx';
import type { CustomFiltersState } from './types.tsx';

const initialState: CustomFiltersState = { filters: [] };

export function customFiltersReducer(
	state: CustomFiltersState = initialState,
	action: Action,
): CustomFiltersState {
	switch (action.type) {
		case LOAD_CONFIG_DATA_MODEL_SUCCESS: {
			const filters = action.payload.entities.quickFilters;
			return { filters };
		}
		case SET_CUSTOM_FILTERS:
			return { filters: action.payload };
		default:
			return state;
	}
}
